import LocalizationProvider from "@mui/lab/LocalizationProvider";
import {
    Box,
    FormControl,
    FormHelperText,
    Grid,
    IconButton,
    MenuItem,
    Select,
    TextField,
    Typography,
    FormControlLabel,
    Checkbox,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { GetCountries } from "react-country-state-city";
import { number } from "yup";
import CharCounter from "../../../components/CharCounter";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import DeleteIcon from "@mui/icons-material/Delete";
import { DateTimePicker } from "@mui/lab";
import useAuth from "../../../hooks/useAuth";

export default function SuggestionsComponent({
    suggestion,
    indexOfSuggstion,
    handleChange,
    handleRemoveSuggestion,
    SuggestionErrors,
    SuggestionTouched,
    SuggestionBlur,
    isDisabled,
    formik,
    orglevelLinkAnalyticsPermission = false,
}) {
    const { user } = useAuth();
    let enableUrlAnalytics = suggestion?.enableUrlAnalytics;
    if ((enableUrlAnalytics === undefined || enableUrlAnalytics === null) && orglevelLinkAnalyticsPermission) {
        enableUrlAnalytics = true;
    }

    const reply = "reply";
    const urlAction = "url_action";
    const dialerAction = "dialer_action";
    const query = "view_location_query";
    const calendarEvent = "calendar_event";
    const [countriesList, setCountriesList] = useState([]);
    const currentDateTime = new Date();
    const [startDate, setStartDate] = useState(currentDateTime);
    const [endDate, setEndDate] = useState(currentDateTime);

    const onFieldChange = e => {
        const { name, value } = e.target;
        // if(name==="suggestionText"){
        //   if(value.length<=25){
        //     handleChange({ field: name, value, indexOfSuggstion });

        //   }else{
        //     formik.setFieldError(name,"")
        //   }

        // }else{

        handleChange({ field: name, value, indexOfSuggstion });
        // }
    };

    const handleCountryName = value => {
        // const { name, value } = e.target;

        const country = countriesList.filter(country => {
            return country.name === value;
        })[0];

        onFieldChange({ target: { name: "phoneNumberToDial.country", value: value } });
        onFieldChange({ target: { name: "phoneNumberToDial.countryCode", value: country.phone_code } });
    };
    const onClickRemoveSuggestion = () => {
        handleRemoveSuggestion({ indexOfSuggstion });
    };

    const getCountriesName = async () => {
        await GetCountries().then(result => {
            setCountriesList(result);
        });
    };

    const handleStartDateChange = date => {
        setStartDate(date);
        // calculateTimeDifferenceInSeconds(date);
    };
    const handleEndDateChange = date => {
        setEndDate(date);
        // calculateTimeDifferenceInSeconds(date);
    };

    useEffect(() => {
        if (suggestion.typeOfAction === dialerAction) {
            getCountriesName();
        }
    }, [suggestion.typeOfAction]);

    // initialize enableUrlAnalytics when url_action is selected and org has permission
    useEffect(() => {
        if (
            suggestion.typeOfAction === urlAction &&
            orglevelLinkAnalyticsPermission === true &&
            suggestion.enableUrlAnalytics === undefined
        ) {
            onFieldChange({ target: { name: "enableUrlAnalytics", value: true } });
        }
    }, [suggestion.typeOfAction, orglevelLinkAnalyticsPermission, suggestion.enableUrlAnalytics]);

    return (
        <Box
            key={indexOfSuggstion}
            sx={{
                borderRadius: 1,
                border: "2px solid rgb(209 213 219)",
                padding: 5,
            }}
            className="col"
        >
            <Grid display={"flex"} justifyContent={"end"}>
                {!isDisabled && (
                    <Box>
                        <IconButton
                            // variant="contained"
                            disabled={isDisabled}
                            size="small"
                            color="error"
                            onClick={() => onClickRemoveSuggestion()}
                        >
                            <DeleteIcon />
                        </IconButton>
                        {/* <Button
              disabled={isDisabled}
              variant="contained"
              type="button"
              onClick={() => onClickRemoveSuggestion()}
              sx={{ borderRadius: 50 }}
              color={"error"}
            >
              X
            </Button> */}
                    </Box>
                )}
            </Grid>
            <Box className="row ">
                <Grid className="col-3 " sx={{ mb: "21px" }}>
                    <FormControl fullWidth error={SuggestionTouched?.typeOfAction && SuggestionErrors?.typeOfAction}>
                        {/* <InputLabel id="action-type">Action Type</InputLabel> */}

                        <Typography fontWeight={"bold"} mb={2}>
                            Action Type
                        </Typography>
                        <Select
                            name="typeOfAction"
                            onChange={onFieldChange}
                            value={suggestion?.typeOfAction}
                            label="Type of Action"
                            labelId="action-type"
                            id="demo-simple-select"
                            error={Boolean(SuggestionTouched?.typeOfAction && SuggestionErrors?.typeOfAction)}
                            disabled={isDisabled}
                            helperText={SuggestionTouched?.typeOfAction && SuggestionErrors?.typeOfAction}
                            onBlur={SuggestionBlur}
                            sx={{
                                "& legend": { display: "none" },
                                "& fieldset": { top: 0 },
                            }}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        GridShadow: " 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                                    },
                                },
                            }}
                        >
                            <MenuItem value={reply}>Reply </MenuItem>
                            <MenuItem value={urlAction}>URL Action</MenuItem>
                            <MenuItem value={dialerAction}>Dialer Action</MenuItem>

                            {user?.orgDetails?.supportedProviders[0]?.providerCode === "VI_INDIA" && <MenuItem value={query}>View Location</MenuItem>}

                            {user?.orgDetails?.supportedProviders[0]?.providerCode === "VI_INDIA" && (
                                <MenuItem value={calendarEvent}>Create Calendar Event</MenuItem>
                            )}
                        </Select>
                        <FormHelperText>{SuggestionTouched?.typeOfAction && SuggestionErrors?.typeOfActions}</FormHelperText>
                    </FormControl>
                </Grid>
                {suggestion?.typeOfAction === reply && (
                    <Box className="col-8 row">
                        <Box className="col-8">
                            <Typography>
                                <b className="text-dark-50 m-2">Button Text</b>
                            </Typography>
                            <TextField
                                className="m-2"
                                fullWidth
                                sx={{
                                    "& legend": { display: "none" },
                                    "& fieldset": { top: 0 },
                                }}
                                value={suggestion?.suggestionText}
                                multiline
                                rows={1}
                                maxRows={1}
                                name="suggestionText"
                                onChange={onFieldChange}
                                error={Boolean(SuggestionTouched?.suggestionText && SuggestionErrors?.suggestionText)}
                                helperText={SuggestionTouched?.suggestionText && SuggestionErrors?.suggestionText}
                                disabled={isDisabled}
                                onBlur={SuggestionBlur}
                                inputProps={{
                                    maxLength: 25,
                                }}
                            />

                            {/* <Grid sx={{display: "flex", justifyContent: "space-between"}}> */}
                            {/* <FormHelperText sx={{color:"#e90e0ede"}}  >
              {SuggestionTouched?.suggestionText &&
                  SuggestionErrors?.suggestionText}
            </FormHelperText> */}
                            <Box
                                sx={{
                                    px: 1,
                                    mx: 1,
                                    // fontSize: "0.875rem",
                                    // fontWeight: "700",
                                    display: "flex",
                                    flexDirection: "row-reverse",
                                }}
                            >
                                {CharCounter(suggestion?.suggestionText)}
                                /25
                            </Box>
                            {/* </Grid>  */}
                        </Box>
                        {/* <Box className="col-6">
              <Typography >
                <b className="text-dark-50 m-2">
                  Button Postback
                </b>
              </Typography>
              <TextField
                className="m-2"
                fullWidth
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                multiline
                rows={1}
                maxRows={1}
                name="suggestionPostback"
                onChange={onFieldChange}
                value={suggestion?.suggestionPostback}
                error={Boolean(
                  SuggestionTouched?.suggestionPostback &&
                  SuggestionErrors?.suggestionPostback
                )}
                helperText={
                  SuggestionTouched?.suggestionPostback &&
                  SuggestionErrors?.suggestionPostback
                }
                disabled={true}
                onBlur={SuggestionBlur}
              />
              <React.Fragment>

                <Box
                  sx={{
                    px: 1,
                    mx: 1,
                    // fontSize: "0.875rem",
                    // fontWeight: "700",
                    display: "flex",
                    flexDirection: "row-reverse",
                  }}
                >
                  {CharCounter(suggestion?.suggestionPostback)}
                  /120
                </Box>
              </React.Fragment>
            </Box> */}
                    </Box>
                )}
                {suggestion?.typeOfAction === urlAction && (
                    <>
                        {/* renders: title, button name input, button name input length*/}
                        <Box className="col-9 row align-items-center">
                            <Box className="col-6">
                                {/* "Button Text" title */}
                                <Typography>
                                    <b className="text-dark-50 m-2">Button Text</b>
                                </Typography>
                                {/* "Button Text" input field (maxLength=25) */}
                                <TextField
                                    className="m-2"
                                    fullWidth
                                    sx={{
                                        "& legend": { display: "none" },
                                        "& fieldset": { top: 0 },
                                    }}
                                    multiline
                                    rows={1}
                                    maxRows={1}
                                    name="suggestionText"
                                    onChange={onFieldChange}
                                    value={suggestion?.suggestionText}
                                    error={Boolean(SuggestionTouched?.suggestionText && SuggestionErrors?.suggestionText)}
                                    helperText={SuggestionTouched?.suggestionText && SuggestionErrors?.suggestionText}
                                    onBlur={SuggestionBlur}
                                    disabled={isDisabled}
                                    inputProps={{
                                        maxLength: 25,
                                    }}
                                />
                                {/* "Button Text" input length (maxLength=25) */}
                                <Box
                                    sx={{
                                        px: 1,
                                        mx: 1,
                                        // fontSize: "0.875rem",
                                        // fontWeight: "700",
                                        display: "flex",
                                        flexDirection: "row-reverse",
                                    }}
                                >
                                    {CharCounter(suggestion?.suggestionText)}
                                    /25
                                </Box>
                            </Box>
                        </Box>
                        {/* renders: title, input url, enableUrlAnalytics checkbox */}
                        <Box className="col-9">
                            <Typography>
                                <b className="text-dark-50 m-2">URL to Open</b>
                            </Typography>
                            <Box>
                                <TextField
                                    className="m-2"
                                    fullWidth
                                    // sx={{
                                    //     "& legend": { display: "none" },
                                    //     "& fieldset": { top: 0 },
                                    // }}
                                    multiline
                                    // rows={1}
                                    // maxRows={1}
                                    name="urlAction"
                                    onChange={onFieldChange}
                                    value={suggestion?.urlAction}
                                    error={Boolean(SuggestionTouched?.urlAction && SuggestionErrors?.urlAction)}
                                    helperText={SuggestionTouched?.urlAction && SuggestionErrors?.urlAction}
                                    onBlur={SuggestionBlur}
                                    disabled={isDisabled}
                                />
                                {orglevelLinkAnalyticsPermission === true && (
                                    <FormControlLabel
                                        className="m-0"
                                        control={
                                            <Checkbox
                                                name="enableUrlAnalytics"
                                                value={enableUrlAnalytics}
                                                checked={enableUrlAnalytics}
                                                onChange={e => onFieldChange({ target: { name: "enableUrlAnalytics", value: e.target.checked } })}
                                                disabled={isDisabled}
                                            />
                                        }
                                        label="Enable URL Analytics"
                                    />
                                )}
                            </Box>
                        </Box>
                    </>
                )}
                {suggestion.typeOfAction === dialerAction && (
                    <>
                        <Box className="col-9 row">
                            <Box className="col-6">
                                <Typography>
                                    <b className="text-dark-50 m-2">Button Text</b>
                                </Typography>
                                <TextField
                                    className="m-2"
                                    fullWidth
                                    sx={{
                                        "& legend": { display: "none" },
                                        "& fieldset": { top: 0 },
                                    }}
                                    multiline
                                    rows={1}
                                    maxRows={1}
                                    name="suggestionText"
                                    onChange={onFieldChange}
                                    value={suggestion?.suggestionText}
                                    error={Boolean(SuggestionTouched?.suggestionText && SuggestionErrors?.suggestionText)}
                                    helperText={SuggestionTouched?.suggestionText && SuggestionErrors?.suggestionText}
                                    onBlur={SuggestionBlur}
                                    disabled={isDisabled}
                                    inputProps={{
                                        maxLength: 25,
                                    }}
                                />
                                <React.Fragment>
                                    <Box
                                        sx={{
                                            px: 1,
                                            mx: 1,
                                            // fontSize: "0.875rem",
                                            // fontWeight: "700",
                                            display: "flex",
                                            flexDirection: "row-reverse",
                                        }}
                                    >
                                        {CharCounter(suggestion?.suggestionText)}
                                        /25
                                    </Box>
                                </React.Fragment>
                            </Box>
                            {/* <Box className="col-6">
              <Typography >
                <b className="text-dark-50 m-2">
                  Button Postback
                </b>
              </Typography>
              <TextField
                className="m-2"
                fullWidth
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                multiline
                rows={1}
                maxRows={1}
                name="suggestionPostback"
                onChange={onFieldChange}
                value={suggestion?.suggestionPostback}
                error={Boolean(
                  SuggestionTouched?.suggestionPostback &&
                  SuggestionErrors?.suggestionPostback
                )}
                helperText={
                  SuggestionTouched?.suggestionPostback &&
                  SuggestionErrors?.suggestionPostback
                }
                onBlur={SuggestionBlur}
                disabled={true}
              />
              <React.Fragment>
                <Box
                  sx={{
                    px: 1,
                    mx: 1,
                    // fontSize: "0.875rem",
                    // fontWeight: "700",
                    display: "flex",
                    flexDirection: "row-reverse",
                  }}
                >
                  {CharCounter(suggestion?.suggestionPostback)}
                  /120
                </Box>
              </React.Fragment>
            </Box> */}
                        </Box>

                        <Box className="col-3">
                            <Typography>
                                <b className="text-dark-50 m-2">Country Name</b>
                            </Typography>
                            <Select
                                className="m-2"
                                id="countryId"
                                sx={{
                                    "& legend": { display: "none" },
                                    "& fieldset": { top: 0 },
                                }}
                                name="phoneNumberToDial.country"
                                disabled={isDisabled}
                                value={suggestion.phoneNumberToDial?.country}
                                onBlur={SuggestionBlur}
                                onChange={e => {
                                    handleCountryName(e.target.value);
                                }}
                                MenuProps={{
                                    PaperProps: {
                                        style: {
                                            maxHeight: "250px", // Adjust the maxHeight as per your requirement
                                            width: "230px",
                                        },
                                    },
                                }}
                            >
                                {/* <Grid height={'250px'} width={'225px'}> */}
                                {countriesList.map(item => (
                                    <MenuItem value={item.name} sx={{ display: "grid", placeItems: "center", fontSize: "0.8rem" }}>
                                        {item.name}
                                    </MenuItem>
                                ))}
                                {/* </Grid> */}
                            </Select>
                        </Box>
                        <Box className="col-3">
                            <Typography>
                                <b className="text-dark-50 m-2">Country Code</b>
                            </Typography>
                            <TextField
                                className="m-2"
                                sx={{
                                    "& legend": { display: "none" },
                                    "& fieldset": { top: 0 },
                                }}
                                name="phoneNumberToDial.countryCode"
                                disabled={isDisabled}
                                value={suggestion.phoneNumberToDial?.countryCode}
                                onBlur={SuggestionBlur}
                            />
                        </Box>

                        <Box className="col-5">
                            <Typography>
                                <b className="text-dark-50 m-2">Phone Number To Dial</b>
                            </Typography>
                            <TextField
                                className="m-2"
                                sx={{
                                    "& legend": { display: "none" },
                                    "& fieldset": { top: 0 },
                                }}
                                type="tel"
                                value={suggestion.phoneNumberToDial?.number}
                                name="phoneNumberToDial.number"
                                onChange={e => {
                                    const cleaned = e.target.value.replace(/[^0-9]/g, "");
                                    onFieldChange({ target: { name: "phoneNumberToDial.number", value: cleaned } });
                                }}
                                onBlur={SuggestionBlur}
                                disabled={isDisabled}
                                error={Boolean(SuggestionErrors?.phoneNumberToDial?.number)}
                                helperText={SuggestionErrors?.phoneNumberToDial?.number}
                                inputProps={{ minLength: 7, maxLength: 15, inputMode: "numeric", pattern: "[0-9]*" }}
                            />
                        </Box>
                    </>
                )}
                {suggestion.typeOfAction === query && (
                    <>
                        <Box className="col-9 row">
                            <Box className="col-6">
                                <Typography>
                                    <b className="text-dark-50 m-2">Button Text</b>
                                </Typography>
                                <TextField
                                    className="m-2"
                                    fullWidth
                                    sx={{
                                        "& legend": { display: "none" },
                                        "& fieldset": { top: 0 },
                                    }}
                                    multiline
                                    rows={1}
                                    maxRows={1}
                                    name="suggestionText"
                                    onChange={onFieldChange}
                                    value={suggestion?.suggestionText}
                                    error={Boolean(SuggestionTouched?.suggestionText && SuggestionErrors?.suggestionText)}
                                    helperText={SuggestionTouched?.suggestionText && SuggestionErrors?.suggestionText}
                                    onBlur={SuggestionBlur}
                                    disabled={isDisabled}
                                    inputProps={{
                                        maxLength: 25,
                                    }}
                                />
                                <React.Fragment>
                                    <Box
                                        sx={{
                                            px: 1,
                                            mx: 1,
                                            // fontSize: "0.875rem",
                                            // fontWeight: "700",
                                            display: "flex",
                                            flexDirection: "row-reverse",
                                        }}
                                    >
                                        {CharCounter(suggestion?.suggestionText)}
                                        /25
                                    </Box>
                                </React.Fragment>
                            </Box>
                        </Box>
                        <Box className="col-9">
                            <Typography>
                                <b className="text-dark-50 m-2">Location Query</b>
                            </Typography>
                            <TextField
                                className="m-2"
                                fullWidth
                                sx={{
                                    "& legend": { display: "none" },
                                    "& fieldset": { top: 0 },
                                }}
                                multiline
                                type={number}
                                value={suggestion?.query}
                                // rows={1}
                                // maxRows={1}
                                name="query"
                                onChange={onFieldChange}
                                disabled={isDisabled}
                                error={Boolean(SuggestionTouched?.query && SuggestionErrors?.query)}
                                helperText={SuggestionTouched?.query && SuggestionErrors?.query}
                                onBlur={SuggestionBlur}
                            />
                            <React.Fragment>
                                <Box
                                    sx={{
                                        px: 1,
                                        mx: 1,
                                        // fontSize: "0.875rem",
                                        // fontWeight: "700",
                                        display: "flex",
                                        flexDirection: "row-reverse",
                                    }}
                                >
                                    {CharCounter(suggestion?.query)}
                                    /1024
                                </Box>
                            </React.Fragment>
                        </Box>
                    </>
                )}

                {/* calendar event  */}
                {suggestion?.typeOfAction === calendarEvent && (
                    <>
                        <Box className="col-12 row">
                            <Box className="col-6">
                                <Typography>
                                    <b className="text-dark-50 m-2">Suggestion Text</b>
                                </Typography>
                                <TextField
                                    className="m-2"
                                    fullWidth
                                    sx={{
                                        "& legend": { display: "none" },
                                        "& fieldset": { top: 0 },
                                    }}
                                    multiline
                                    rows={1}
                                    maxRows={1}
                                    name="suggestionText"
                                    onChange={onFieldChange}
                                    value={suggestion?.suggestionText}
                                    error={Boolean(SuggestionTouched?.suggestionText && SuggestionErrors?.suggestionText)}
                                    helperText={SuggestionTouched?.suggestionText && SuggestionErrors?.suggestionText}
                                    onBlur={SuggestionBlur}
                                    disabled={isDisabled}
                                    inputProps={{
                                        maxLength: 25,
                                    }}
                                />
                                <Box sx={{ px: 1, mx: 1, display: "flex", flexDirection: "row-reverse" }}>
                                    {CharCounter(suggestion?.suggestionText)} /25
                                </Box>
                            </Box>

                            <Box className="col-6">
                                <Typography>
                                    <b className="text-dark-50 m-2">Event Title</b>
                                </Typography>
                                <TextField
                                    className="m-2"
                                    fullWidth
                                    sx={{
                                        "& legend": { display: "none" },
                                        "& fieldset": { top: 0 },
                                    }}
                                    multiline
                                    // rows={1}
                                    // maxRows={1}
                                    name="title"
                                    onChange={onFieldChange}
                                    value={suggestion?.title}
                                    error={Boolean(SuggestionTouched?.title && SuggestionErrors?.title)}
                                    helperText={SuggestionTouched?.title && SuggestionErrors?.title}
                                    onBlur={SuggestionBlur}
                                    disabled={isDisabled}
                                    inputProps={{
                                        maxLength: 2048,
                                    }}
                                />
                                <Box sx={{ px: 1, mx: 1, display: "flex", flexDirection: "row-reverse" }}>{CharCounter(suggestion?.title)} /2048</Box>
                            </Box>
                        </Box>

                        <Box className="col-12 row">
                            <Box className="col-6">
                                <Typography>
                                    <b className="text-dark-50 m-2">Description</b>
                                </Typography>

                                <Box>
                                    <TextField
                                        className="m-2"
                                        fullWidth
                                        sx={{
                                            "& legend": { display: "none" },
                                            "& fieldset": { top: 0 },
                                        }}
                                        multiline
                                        // rows={1}
                                        // maxRows={1}
                                        name="description"
                                        onChange={onFieldChange}
                                        value={suggestion?.description}
                                        error={Boolean(SuggestionTouched?.description && SuggestionErrors?.description)}
                                        helperText={SuggestionTouched?.description && SuggestionErrors?.description}
                                        onBlur={SuggestionBlur}
                                        disabled={isDisabled}
                                        inputProps={{
                                            maxLength: 2048,
                                        }}
                                    />
                                    <Box sx={{ px: 1, mx: 1, display: "flex", flexDirection: "row-reverse" }}>
                                        {CharCounter(suggestion?.description)} /2048
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                        <Box className="col-12 row mt-4" sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Box className="col-6 row  ">
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DateTimePicker
                                        label="Start Date and Time"
                                        value={suggestion?.startTime}
                                        onChange={value => onFieldChange({ target: { value, name: "startTime" } })}
                                        minDateTime={new Date()}
                                        renderInput={params => <TextField {...params} />}
                                    />
                                </LocalizationProvider>
                            </Box>
                            <Box className="col-6 row ">
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DateTimePicker
                                        label="End Date and Time"
                                        value={suggestion?.endTime}
                                        onChange={value => onFieldChange({ target: { value, name: "endTime" } })}
                                        minDateTime={suggestion?.startTime ? new Date(suggestion.startTime) : new Date()}
                                        renderInput={params => <TextField {...params} />}
                                    />
                                </LocalizationProvider>
                            </Box>
                        </Box>
                    </>
                )}
            </Box>
        </Box>
    );
}
